module.exports = __webpack_public_path__ + "static/sm-unwomen-a42734df48a30bc740bf60ceda5f8150.png";